import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './plugins/filters';
import './plugins/logger';
import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.min.css';
import {firestorePlugin} from 'vuefire';

Vue.use(firestorePlugin);

Vue.config.productionTip = false

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
